<jw-modal id='leadAccountModal'>
  @if (this.isError) {
    <div class="alert alert-danger">Please complete all required fields</div>
  }
  @if (this.isServerError) {
    <div class="alert alert-danger">Something went wrong. Please try again later.</div>
  }
  <h1 class='header'>Select Account</h1>

  <div class="row">
    <div class="col">
      <app-grid
        entity='account'
        [inverse]=true
        [filters]='this.filters'
        [columns]='this.columns'
        [buttons]='this.buttons'
        [searchFilters]='this.searchFilters'
        [searchFields]='this.searchFields'
        [radioSelector]='true'
        (radioButtonSelected)='this.onCheckedSelected($event)'
        [amount]='10'
      ></app-grid>
    </div>
  </div>

  @if (!newAccount) {
    <div class="row my-3">
      <div class="col">
        <button class='btn btn-block btn-info' (click)='this.newAccount = true;$event.preventDefault()'>Add New Account</button>
      </div>
    </div>
  }

  @if (newAccount) {
    <div class="row mt-3">
      <div class="col">
        Add New Account
      </div>
    </div>
    <div class="row">
      <div class="form-group col-md-4">
        <label for="accountName">Name</label>
        <input
          type="text"
          name='name'
          [(ngModel)]='this.account.name'
          [class.is-invalid]='!this.account.name'
          class="form-control"
          id="accountName"
          oninput="let p=this.selectionStart;this.value=this.value.toUpperCase();this.setSelectionRange(p, p);"
          >
      </div>
      <div class="form-group col-md-4">
        <label for="accountRef">Account Ref</label>
        <input type="text" name='name' [(ngModel)]='this.account.accountRef' [class.is-invalid]='this.account.accountRef === ""'  [class.is-valid]='this.account.accountRef !== ""' class="form-control" id="accountRef">
      </div>
      <div class="form-group col-md-4">
        <label for="phoneNumber">Phone Number</label>
        <input type="text" name='name' [(ngModel)]='this.account.phoneNumber' class="form-control" id="phoneNumber">
      </div>
      <div class="form-group col-md-4">
        <label for="billing1">Address Line 1</label>
        <input type="text" name='name' [(ngModel)]='this.account.billingAddress1' class="form-control" id="billing1">
      </div>
      <div class="form-group col-md-4">
        <label for="billing2">Address Line 2</label>
        <input type="text" name='name' [(ngModel)]='this.account.billingAddress2' class="form-control" id="billing2">
      </div>
      <div class="form-group col-md-4">
        <label for="billing3">City</label>
        <input type="text" name='name' [(ngModel)]='this.account.billingCity' class="form-control" id="billing3">
      </div>
      <div class="form-group col-md-4">
        <label for="billing4">Country</label>
        <input type="text" name='name' [(ngModel)]='this.account.billingCountry' class="form-control" id="billing4">
      </div>
      <div class="form-group col-md-4">
        <label for="billing5">Postcode</label>
        <input type="text" name='name' [(ngModel)]='this.account.billingPostCode' class="form-control" id="billing5">
        <app-address-picker [postcode]='this.account.billingPostCode' (onAddressFound)='this.foundBillingAddress($event)'></app-address-picker>
      </div>
    </div>
    <div class="row mb-3">
      <div class="col">
        <button class='btn btn-success' (click)='this.save()'>Add Account</button>
        <button class='btn btn-danger' (click)='this.clearNewAccount()'>Clear new Account</button>
      </div>
    </div>
  }

  <div class="row">
    <div class="col">
      <button class='btn btn-danger' (click)='this.cancel()'>Cancel</button>
    </div>
  </div>





</jw-modal>
